// extracted by mini-css-extract-plugin
export default {"pokerTableOverlapCard":"CardFace_pokerTableOverlapCard__2vpPT","pokerTableCardElevated":"CardFace_pokerTableCardElevated__xfMV9"};